<mat-drawer-container
  *ngIf="sideDrawerTemplate$ | async as sideDrawer; else page"
  id="help-side-drawer-container"
  class="side-drawer-container"
  hasBackdrop="false"
>
  <mat-drawer [mode]="modeType" position="end" autoFocus="false" class="side-drawer">
    <ng-template [ngTemplateOutlet]="sideDrawer.templateRef"></ng-template>
  </mat-drawer>
  <mat-drawer-content class="side-drawer-content">
    <ng-container [ngTemplateOutlet]="page"></ng-container>
  </mat-drawer-content>
</mat-drawer-container>
<ng-template #page>
  <app-trial-banner></app-trial-banner>
  <div class="page-content-container">
    <ng-content></ng-content>
  </div>
</ng-template>
